module.exports = {
  china: 'cn',
  default: 'ww',
  france: 'fr',
  russia: 'ru',
  unitedStates: 'us',
};
